// @flow

import { rest } from 'msw'

export const getFaviconMswHandler = rest.get('http://localhost:3000/favicon.ico', (req, res, ctx) => {
  return res(ctx.status(200))
})
